var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cz2__ai-modal__loading"},[_c('div',{staticClass:"cz2__modal-popup__header"},[_vm._v(" "+_vm._s(_vm.heading)+" ")]),_c('p',{staticClass:"cz2__modal-popup__copy"},[_vm._v(" "+_vm._s(_vm.copy)+" ")]),_c('funko-spinner',{attrs:{"is-ai-modal":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }